export const reportFormat = {
  PDF: {
    value: 'PDF',
    label: 'PDF',
    icon: 'mdi-file-pdf',
    color: 'red'
  },
  XLS: {
    value: 'XLS',
    label: 'Excel',
    icon: 'mdi-file-excel',
    color: 'green'
  }
}
